import {onFind} from "@elements/init-modules-in-scope";
import { findAllIn, removeClass, addClass, findIn, on } from "@elements/dom-utils";
export function init() {
    onFind('.js-filter-counter', (filterCounter) => {
        let dropdown = findAllIn('.js-dropdown-counter', filterCounter);
        let datepickerInputs = findAllIn('.js-datepicker__input', filterCounter);
        let countTotalText = findIn('.js-dropdown-counter__text--total', filterCounter);
        let countTotalCounter = findIn('.js-dropdown-counter__counter--total', filterCounter);

        dropdown.forEach( function (item) {
            let dropdownInputs = findAllIn( '.js-dropdown-counter__input', item);
            let counterText = findIn('.js-dropdown-counter__text', item);
            let counterCounter = findIn('.js-dropdown-counter__counter', item);

            //opacity-0
            dropdownInputs.forEach(function (input) {
                if(input.checked){
                    counterText.innerText++;
                    countTotalText.innerText++;
                    removeClass('opacity-0', counterCounter );
                }
                on('click', function () {
                    if(input.checked){
                        counterText.innerText++;
                        countTotalText.innerText++;
                    }else{
                        counterText.innerText--;
                        countTotalText.innerText--;
                    }
                    if(counterText.innerText > 0){
                        removeClass('opacity-0', counterCounter );
                    }
                    else{
                        addClass('opacity-0', counterCounter);
                    }
                    showHideTotalCounter(countTotalText, countTotalCounter);
                }, input);

            });
        });

        datepickerInputs.forEach( function (input) {
            let datepickerHiddenInput = findIn('.js-datepicker__alt-field', input.parentElement);
            on('change', function () {
                if (datepickerHiddenInput.value === '') {
                    countTotalText.innerText--;
                }
                else {
                    countTotalText.innerText++;
                }
                showHideTotalCounter(countTotalText, countTotalCounter);
            }, input);
        });
    });
}

function showHideTotalCounter(countTotalText, countTotalCounter) {
    if(countTotalText.innerText > 0){
        removeClass('opacity-0', countTotalCounter );
    }
    else {
        addClass('opacity-0', countTotalCounter );
    }
}